import Vue from 'vue';

import PopupContent from '../components/PopupContent/PopupContent.vue';
import vuetify from '../plugins/vuetify';

import type { CompositeRead } from '@nextgisweb/resource/type/api';
import type { Feature } from 'geojson';

let CREATED_POPUP: Vue[] = [];

const destroyCreatedPopup = () => {
  for (const p of CREATED_POPUP) {
    p.$destroy();
  }
  CREATED_POPUP = [];
};

export function createPopupContentComponent(
  feature: Feature,
  item?: CompositeRead,
): HTMLElement | string {
  destroyCreatedPopup();
  const id = `popup-id-${item ? item.resource.id : 'default'}-${feature.id}`;
  const element = document.createElement('div');
  element.id = id;
  element.innerHTML = '';
  element.style.height = '400px';
  // Mount vue component only after insert element in dom
  setTimeout(async () => {
    let container: HTMLElement | null = null;
    const iframe = document.getElementsByClassName(
      'cesium-infoBox-iframe',
    )[0] as HTMLIFrameElement;
    if (iframe) {
      const wrapper = document.createElement('div');
      wrapper.className = 'popup-container-to-replace';
      container = iframe;
    } else {
      container = document.getElementsByClassName(
        'feature-popup-container',
      )[0] as HTMLElement;
    }

    if (container) {
      const popupContentComponent = new Vue({
        vuetify,
        render: (h) => {
          return h(PopupContent, { props: { feature, item } });
        },
      });
      popupContentComponent.$mount(container);
      CREATED_POPUP.push(popupContentComponent);
    }
  }, 10);
  return element;
}
